import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { DynamicShareButtonContainer }
from '@fuww/library/src/Article';
import loading from '../../../lib/loading';

const DynamicShareButton = dynamic(() => import(
  '@fuww/library/src/SocialShare/index'
), {
  ssr: false,
  loading,
});

const SocialButtons = ({ shareList }) => (
  <DynamicShareButtonContainer center>
    <DynamicShareButton
      data={shareList}
    />
  </DynamicShareButtonContainer>
);

SocialButtons.propTypes = {
  shareList: PropTypes.arrayOf(PropTypes.shape({})),
};

SocialButtons.defaultProps = {
  shareList: [],
};

export default SocialButtons;
